export const GET_PAYMENT_METHOD_DEF = "/PaymentMethodDef/GetAllPaymentMethodDef"